import { ReactElement, useState } from 'react';

import { Internship } from '@backrs_ui/common-ui/src/models/internship';

import { Box, SxProps, Theme } from '@mui/material';

import { BackrsAssessment } from './BackrsAssessment';
import { QuickLook } from './QuickLook';

type NuggetInternshipLargeProps = Readonly<{
  internshipInfo: Internship;
}>;

export function NuggetInternshipLarge({
  internshipInfo,
}: NuggetInternshipLargeProps): ReactElement {
  const [isLogoLinkValid, setIsLogoLinkValid] = useState(true);

  return (
    <Box sx={largeInternshipContainerStyle}>
      {internshipInfo.ai_description}

      <Box sx={textContainerStyle}>
        <QuickLook internshipInfo={internshipInfo} />
        <BackrsAssessment />
      </Box>

      {internshipInfo.logo_link && isLogoLinkValid && (
        <Box
          component="img"
          src={internshipInfo.logo_link}
          alt="Internship"
          sx={logoImageStyle}
          onError={() => setIsLogoLinkValid(false)}
        />
      )}
    </Box>
  );
}

const largeInternshipContainerStyle: SxProps<Theme> = {
  mt: 3,
  gap: 2,
  display: 'flex',
  flexDirection: 'column',
};

const textContainerStyle: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 11fr)',
  mt: 3,
  gap: 2,
};

const logoImageStyle: SxProps<Theme> = {
  maxWidth: '100px',
  minWidth: '100px',
  maxHeight: '100px',
  width: 'auto',
  height: 'auto',
  objectFit: 'contain',
  alignSelf: 'flex-end',
  mt: 0,
  ml: 4,
};
